/* XP DTF gang sheet builder. Customers upload art, set sizes and copies;
   we auto-pack it onto the film, pick the smallest sheet size (product variant)
   the layout fits on, and send the layout comp plus the original files to the
   cart as line item properties (Shopify's native file uploads, no app).
   Add to cart requires artwork on the sheet AND the rights checkbox. */
(function () {
  'use strict';

  var EPS = 1e-6;
  var SIZE_STEP = 0.25; // inches per click of the width/height arrows

  function snap(n) { return Math.round(n * 20) / 20; } // nearest 0.05 in
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function contains(a, b) {
    return b.x >= a.x - EPS && b.y >= a.y - EPS &&
      b.x + b.w <= a.x + a.w + EPS && b.y + b.h <= a.y + a.h + EPS;
  }

  /* MaxRects with a bottom-left score, so the sheet stays as short as possible. */
  function pack(items, usable, gap) {
    var list = items.slice().sort(function (a, b) {
      return (Math.max(b.w, b.h) - Math.max(a.w, a.h)) || (b.w * b.h - a.w * a.h);
    });
    var free = [{ x: 0, y: 0, w: usable + gap, h: 1e6 }];
    var placed = [];
    var bottom = 0;

    list.forEach(function (it) {
      var opts = [[it.w + gap, it.h + gap, false]];
      if (Math.abs(it.w - it.h) > EPS) opts.push([it.h + gap, it.w + gap, true]);
      var best = null;
      free.forEach(function (f) {
        opts.forEach(function (o) {
          if (o[0] <= f.w + EPS && o[1] <= f.h + EPS) {
            var s1 = f.y + o[1], s2 = f.x;
            if (!best || s1 < best.s1 - EPS || (Math.abs(s1 - best.s1) <= EPS && s2 < best.s2)) {
              best = { x: f.x, y: f.y, w: o[0], h: o[1], rot: o[2], s1: s1, s2: s2 };
            }
          }
        });
      });
      if (!best) return;

      var n = best, next = [];
      free.forEach(function (f) {
        if (n.x >= f.x + f.w - EPS || n.x + n.w <= f.x + EPS || n.y >= f.y + f.h - EPS || n.y + n.h <= f.y + EPS) {
          next.push(f); return;
        }
        if (n.x > f.x + EPS) next.push({ x: f.x, y: f.y, w: n.x - f.x, h: f.h });
        if (n.x + n.w < f.x + f.w - EPS) next.push({ x: n.x + n.w, y: f.y, w: f.x + f.w - n.x - n.w, h: f.h });
        if (n.y > f.y + EPS) next.push({ x: f.x, y: f.y, w: f.w, h: n.y - f.y });
        if (n.y + n.h < f.y + f.h - EPS) next.push({ x: f.x, y: n.y + n.h, w: f.w, h: f.y + f.h - n.y - n.h });
      });
      free = next.filter(function (a, i) {
        return !next.some(function (b, j) {
          return j !== i && contains(b, a) && (!contains(a, b) || j < i);
        });
      });

      placed.push({ ref: it.ref, x: n.x, y: n.y, w: n.w - gap, h: n.h - gap, rot: n.rot });
      bottom = Math.max(bottom, n.y + n.h - gap);
    });

    return { placed: placed, bottom: bottom, dropped: list.length - placed.length };
  }

  function init(root) {
    var cfg = {
      W: parseFloat(root.dataset.width) || 22,
      min: 12,
      max: 480,
      gap: parseFloat(root.dataset.gap) || 0.25,
      edge: parseFloat(root.dataset.edge) || 0.25,
      tiers: JSON.parse(root.dataset.tiers || '[]').sort(function (a, b) { return a.len - b.len; }),
      addUrl: root.dataset.addUrl || '/cart/add.js',
      cartUrl: root.dataset.cartUrl || '/cart',
      maxFiles: 20,
      maxMB: 20,
      maxPieces: 500
    };
    cfg.usable = cfg.W - 2 * cfg.edge;
    if (cfg.tiers.length) { cfg.min = cfg.tiers[0].len; cfg.max = cfg.tiers[cfg.tiers.length - 1].len; }
    function tierFor(inches) {
      for (var i = 0; i < cfg.tiers.length; i++) if (cfg.tiers[i].len >= inches - EPS) return cfg.tiers[i];
      return null;
    }

    var $ = function (s) { return root.querySelector(s); };
    var els = {
      input: $('[data-xgs-input]'),
      drop: $('[data-xgs-drop]'),
      list: $('[data-xgs-list]'),
      sheet: $('[data-xgs-sheet]'),
      pieces: $('[data-xgs-pieces]'),
      ruler: $('[data-xgs-ruler]'),
      empty: $('[data-xgs-empty]'),
      notes: $('[data-xgs-notes]'),
      rights: $('[data-xgs-rights]'),
      add: root.querySelectorAll('[data-xgs-add]'),
      msg: $('[data-xgs-msg]'),
      room: $('[data-xgs-room]'),
      mbar: $('[data-xgs-mbar]')
    };
    var out = {};
    root.querySelectorAll('[data-o]').forEach(function (n) {
      (out[n.dataset.o] = out[n.dataset.o] || []).push(n);
    });
    function setOut(k, v) { (out[k] || []).forEach(function (n) { n.textContent = v; }); }

    var designs = [];
    var layout = { placed: [], length: cfg.min, need: 0, tier: cfg.tiers[0] || null };
    var uid = 0;
    var busy = false;

    function say(text, kind) {
      els.msg.textContent = text || '';
      els.msg.dataset.kind = kind || '';
    }
    function rightsOK() { return !els.rights || els.rights.checked; }

    /* ---------- sizing ---------- */
    function fit(d, w) {
      w = Math.max(0.5, w);
      var h = w * d.ratio;
      var longest = cfg.max - 2 * cfg.edge;
      if (Math.min(w, h) > cfg.usable) { var s = cfg.usable / Math.min(w, h); w *= s; h *= s; }
      if (Math.max(w, h) > longest) { var t = longest / Math.max(w, h); w *= t; h *= t; }
      d.w = snap(w);
      d.h = snap(d.w * d.ratio);
    }
    function quality(d) {
      if (d.vector) return { cls: 'sharp', text: 'Vector file, prints sharp at any size' };
      var dpi = Math.round(d.px / d.w);
      if (dpi >= 250) return { cls: 'sharp', text: dpi + ' dpi at this size' };
      if (dpi >= 150) return { cls: 'ok', text: dpi + ' dpi at this size, prints fine' };
      return { cls: 'low', text: dpi + ' dpi at this size. It may print soft; a larger file will look better.' };
    }

    /* ---------- files ---------- */
    function addFiles(files) {
      say('');
      Array.prototype.forEach.call(files, function (f) {
        if (designs.length >= cfg.maxFiles) { say('You can add up to ' + cfg.maxFiles + ' designs per sheet.', 'error'); return; }
        if (!/^image\/(png|jpeg|webp|svg\+xml)$/.test(f.type)) { say(f.name + ' is not a supported file. Use PNG, JPG, WEBP or SVG.', 'error'); return; }
        if (f.size > cfg.maxMB * 1048576) { say(f.name + ' is over ' + cfg.maxMB + ' MB. Export a smaller file and add it again.', 'error'); return; }

        var d = { id: ++uid, file: f, name: f.name, copies: 1, vector: f.type === 'image/svg+xml', ready: false };
        d.url = URL.createObjectURL(f);
        d.img = new Image();
        d.img.onload = function () {
          d.px = d.img.naturalWidth || 1200;
          var py = d.img.naturalHeight || d.px;
          d.ratio = py / d.px;
          fit(d, d.vector ? 4 : Math.min(d.px / 300, 10));
          d.ready = true;
          renderList();
          relayout();
        };
        d.img.onerror = function () {
          say(f.name + ' could not be opened. Try exporting it as a PNG.', 'error');
          remove(d.id);
        };
        d.img.src = d.url;
        designs.push(d);
      });
      renderList();
    }
    function remove(id) {
      designs = designs.filter(function (d) {
        if (d.id === id) { URL.revokeObjectURL(d.url); return false; }
        return true;
      });
      renderList();
      relayout();
    }

    /* ---------- list ---------- */
    function stepper(d, field, label, lessLabel, moreLabel) {
      return '<div class="xgs-f"><span id="xgs-' + field + '-' + d.id + '">' + label + '</span>' +
        '<div class="xgs-step"><button type="button" data-dim="' + field + '" data-dir="-1" aria-label="' + lessLabel + '">&minus;</button>' +
        '<input type="number" inputmode="decimal" step="' + SIZE_STEP + '" min="0.5" data-f="' + field + '" value="' + d[field] + '" aria-labelledby="xgs-' + field + '-' + d.id + '">' +
        '<button type="button" data-dim="' + field + '" data-dir="1" aria-label="' + moreLabel + '">+</button></div></div>';
    }
    function renderList() {
      els.list.innerHTML = designs.map(function (d) {
        if (!d.ready) {
          return '<li class="xgs-item is-loading" data-id="' + d.id + '"><div class="xgs-thumb"></div>' +
            '<div class="xgs-meta"><p class="xgs-name">' + esc(d.name) + '</p><p class="xgs-q">Reading file</p></div></li>';
        }
        var q = quality(d);
        return '<li class="xgs-item" data-id="' + d.id + '">' +
          '<div class="xgs-thumb"><img src="' + d.url + '" alt=""></div>' +
          '<div class="xgs-meta">' +
            '<p class="xgs-name" title="' + esc(d.name) + '">' + esc(d.name) + '</p>' +
            '<div class="xgs-fields">' +
              stepper(d, 'w', 'Width (in)', 'Narrower', 'Wider') +
              stepper(d, 'h', 'Height (in)', 'Shorter', 'Taller') +
              '<div class="xgs-f xgs-copies"><span id="xgs-c-' + d.id + '">Copies</span>' +
                '<div class="xgs-step"><button type="button" data-step="-1" aria-label="One fewer copy">&minus;</button>' +
                '<input type="number" inputmode="numeric" min="1" max="' + cfg.maxPieces + '" data-f="copies" value="' + d.copies + '" aria-labelledby="xgs-c-' + d.id + '">' +
                '<button type="button" data-step="1" aria-label="One more copy">+</button></div></div>' +
            '</div>' +
            '<p class="xgs-q q-' + q.cls + '" data-q>' + esc(q.text) + '</p>' +
          '</div>' +
          '<button type="button" class="xgs-x" data-remove aria-label="Remove ' + esc(d.name) + '">&times;</button>' +
        '</li>';
      }).join('');
      root.classList.toggle('has-art', designs.length > 0);
    }
    function syncItem(d, li) {
      li.querySelector('[data-f="w"]').value = d.w;
      li.querySelector('[data-f="h"]').value = d.h;
      li.querySelector('[data-f="copies"]').value = d.copies;
      var q = quality(d), qn = li.querySelector('[data-q]');
      qn.className = 'xgs-q q-' + q.cls;
      qn.textContent = q.text;
    }
    function findDesign(node) {
      var li = node.closest('.xgs-item');
      if (!li) return null;
      var id = +li.dataset.id;
      for (var i = 0; i < designs.length; i++) if (designs[i].id === id) return { d: designs[i], li: li };
      return null;
    }
    function totalPieces(except) {
      return designs.reduce(function (n, d) { return n + (d === except ? 0 : d.copies); }, 0);
    }

    els.list.addEventListener('change', function (e) {
      var t = e.target, hit = findDesign(t);
      if (!hit || !t.dataset.f) return;
      var d = hit.d, v = parseFloat(t.value);
      if (t.dataset.f === 'w' && v > 0) fit(d, v);
      if (t.dataset.f === 'h' && v > 0) fit(d, v / d.ratio);
      if (t.dataset.f === 'copies') {
        var cap = cfg.maxPieces - totalPieces(d);
        d.copies = Math.max(1, Math.min(cap, Math.round(v) || 1));
      }
      syncItem(d, hit.li);
      relayout();
    });
    els.list.addEventListener('click', function (e) {
      var hit = findDesign(e.target);
      if (!hit) return;
      if (e.target.closest('[data-remove]')) { remove(hit.d.id); return; }
      var dim = e.target.closest('[data-dim]');
      if (dim) {
        var inc = SIZE_STEP * (+dim.dataset.dir), d = hit.d;
        if (dim.dataset.dim === 'w') fit(d, d.w + inc);
        else fit(d, (d.h + inc) / d.ratio);
        syncItem(d, hit.li);
        relayout();
        return;
      }
      var step = e.target.closest('[data-step]');
      if (step) {
        var cap = cfg.maxPieces - totalPieces(hit.d);
        hit.d.copies = Math.max(1, Math.min(cap, hit.d.copies + (+step.dataset.step)));
        syncItem(hit.d, hit.li);
        relayout();
      }
    });
    function highlight(id) {
      els.sheet.classList.toggle('is-focus', !!id);
      els.pieces.querySelectorAll('.xgs-pc').forEach(function (p) {
        p.classList.toggle('is-on', +p.dataset.d === id);
      });
    }
    els.list.addEventListener('mouseover', function (e) { var h = findDesign(e.target); highlight(h ? h.d.id : 0); });
    els.list.addEventListener('mouseleave', function () { highlight(0); });
    els.list.addEventListener('focusin', function (e) { var h = findDesign(e.target); highlight(h ? h.d.id : 0); });
    els.list.addEventListener('focusout', function () { highlight(0); });

    /* ---------- layout ---------- */
    function relayout() {
      var items = [];
      designs.forEach(function (d) {
        if (!d.ready) return;
        for (var i = 0; i < d.copies; i++) items.push({ w: d.w, h: d.h, ref: d });
      });
      var res = pack(items, cfg.usable, cfg.gap);
      var need = items.length ? res.bottom + 2 * cfg.edge : 0;
      var tier = tierFor(Math.max(need, cfg.min));
      layout = {
        placed: res.placed,
        need: need,
        tier: tier,
        length: tier ? tier.len : Math.ceil(need - EPS)
      };
      draw();
      summarize();
    }

    function draw() {
      var L = layout.length;
      els.sheet.style.aspectRatio = cfg.W + ' / ' + L;
      els.pieces.innerHTML = layout.placed.map(function (p) {
        var x = (cfg.edge + p.x) / cfg.W * 100, y = (cfg.edge + p.y) / L * 100;
        var w = p.w / cfg.W * 100, h = p.h / L * 100;
        var img = p.rot
          ? '<img src="' + p.ref.url + '" alt="" style="width:' + (p.h / p.w * 100) + '%;height:' + (p.w / p.h * 100) + '%;transform:translate(-50%,-50%) rotate(90deg)" class="is-rot">'
          : '<img src="' + p.ref.url + '" alt="">';
        return '<div class="xgs-pc" data-d="' + p.ref.id + '" style="left:' + x + '%;top:' + y + '%;width:' + w + '%;height:' + h + '%">' + img + '</div>';
      }).join('');
      var hasPieces = layout.placed.length > 0;
      els.empty.hidden = hasPieces;
      els.empty.style.display = hasPieces ? 'none' : '';
      scale();
    }

    function scale() {
      var px = els.sheet.clientWidth / cfg.W;
      if (!px) return;
      els.sheet.style.setProperty('--inch', px + 'px');
      els.ruler.style.setProperty('--inch', px + 'px');
      var L = layout.length, every = L > 120 ? 12 : 6, marks = '';
      for (var i = every; i < L; i += every) {
        marks += '<span style="top:' + (i / L * 100) + '%">' + i + '</span>';
      }
      els.ruler.innerHTML = marks;
    }

    function summarize() {
      var L = layout.length;
      var pieces = layout.placed.length;
      var over = !layout.tier;
      setOut('size', layout.tier ? layout.tier.label : cfg.W + ' \u00d7 ' + L + ' in');
      setOut('pieces', String(pieces));
      setOut('used', pieces ? Math.ceil(layout.need) + ' in of ' + L + ' in' : '0 in');
      setOut('total', money(layout.tier ? layout.tier.price : 0));

      var room = L - layout.need;
      if (pieces && !over && room >= 1) {
        els.room.hidden = false;
        els.room.textContent = 'About ' + Math.floor(room) + ' in of this sheet is still open. Add more art at no extra cost.';
      } else {
        els.room.hidden = true;
      }

      if (over) {
        say('This layout needs ' + Math.ceil(layout.need) + ' in of film. The longest sheet is ' + (cfg.max / 12) + ' ft. Make some designs smaller, remove a few copies, or split it into two orders.', 'error');
      } else if (els.msg.dataset.kind === 'error' && /longest sheet/.test(els.msg.textContent)) {
        say('');
      }
      var artReady = pieces > 0 && !over && designs.every(function (d) { return d.ready; });
      var ready = artReady && rightsOK() && !busy;
      if (els.rights) els.rights.closest('label').classList.toggle('is-needed', artReady && !rightsOK());
      els.add.forEach(function (b) {
        b.disabled = !ready;
        if (!busy) b.textContent = (artReady && !rightsOK()) ? 'Confirm artwork rights' : 'Add to cart';
      });
    }

    /* ---------- comp + cart ---------- */
    function makeComp() {
      return new Promise(function (resolve) {
        var L = layout.length;
        var s = Math.max(8, Math.min(40, Math.floor(12000 / L)));
        var c = document.createElement('canvas');
        c.width = Math.round(cfg.W * s);
        c.height = Math.round(L * s);
        var x = c.getContext('2d');
        x.fillStyle = '#ffffff';
        x.fillRect(0, 0, c.width, c.height);
        x.strokeStyle = 'rgba(0,0,0,0.07)';
        x.lineWidth = 1;
        for (var i = 1; i < cfg.W; i++) { x.beginPath(); x.moveTo(i * s + 0.5, 0); x.lineTo(i * s + 0.5, c.height); x.stroke(); }
        for (var j = 1; j < L; j++) { x.beginPath(); x.moveTo(0, j * s + 0.5); x.lineTo(c.width, j * s + 0.5); x.stroke(); }
        layout.placed.forEach(function (p) {
          var px = (cfg.edge + p.x) * s, py = (cfg.edge + p.y) * s, pw = p.w * s, ph = p.h * s;
          try {
            x.save();
            if (p.rot) {
              x.translate(px + pw / 2, py + ph / 2);
              x.rotate(Math.PI / 2);
              x.drawImage(p.ref.img, -ph / 2, -pw / 2, ph, pw);
            } else {
              x.drawImage(p.ref.img, px, py, pw, ph);
            }
            x.restore();
          } catch (err) { x.restore(); }
          x.strokeStyle = 'rgba(9,110,230,0.6)';
          x.strokeRect(px + 0.5, py + 0.5, pw - 1, ph - 1);
        });
        c.toBlob(function (b) { resolve(b); }, 'image/png');
      });
    }

    function summaryText() {
      return designs.map(function (d) {
        return d.name + ': ' + d.w + ' x ' + d.h + ' in, ' + d.copies + (d.copies === 1 ? ' copy' : ' copies');
      }).join(' | ');
    }

    function addToCart() {
      if (busy || !layout.tier || !rightsOK()) return;
      busy = true;
      summarize();
      els.add.forEach(function (b) { b.textContent = 'Adding to cart'; });
      say('Uploading your artwork. Larger files can take a moment.', 'info');

      makeComp().then(function (comp) {
        var L = layout.length;
        var fd = new FormData();
        fd.append('id', String(layout.tier.id));
        fd.append('quantity', '1');
        fd.append('properties[Film used]', Math.ceil(layout.need) + ' in of ' + L + ' in');
        fd.append('properties[Designs]', summaryText());
        var note = els.notes && els.notes.value.trim();
        if (note) fd.append('properties[Notes]', note);
        fd.append('properties[Artwork Rights Confirmed]', 'Yes');
        if (comp) fd.append('properties[Layout]', comp, 'gang-sheet-layout-' + cfg.W + 'x' + L + '.png');
        designs.forEach(function (d, i) { fd.append('properties[Art ' + (i + 1) + ']', d.file, d.file.name); });
        fd.append('properties[_gang_inches_used]', String(Math.ceil(layout.need)));
        return fetch(cfg.addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'The cart did not accept this sheet.');
        say('Added. Taking you to your cart.', 'info');
        window.location.href = cfg.cartUrl;
      }).catch(function (err) {
        busy = false;
        say((err && err.message ? err.message : 'Something went wrong.') + ' Try again, or call us and we will get it sorted.', 'error');
        summarize();
      });
    }
    els.add.forEach(function (b) { b.addEventListener('click', addToCart); });
    if (els.rights) els.rights.addEventListener('change', summarize);

    /* ---------- upload wiring ---------- */
    els.input.addEventListener('change', function () { addFiles(els.input.files); els.input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      els.drop.addEventListener(ev, function (e) { e.preventDefault(); els.drop.classList.remove('is-over'); });
    });
    els.drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });

    if ('ResizeObserver' in window) new ResizeObserver(scale).observe(els.sheet);
    else window.addEventListener('resize', scale);

    relayout();
  }

  window.XPGangSheet = { pack: pack };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-xgs]').forEach(init);
  });
  else document.querySelectorAll('[data-xgs]').forEach(init);
})();